module.exports = __webpack_public_path__ + "img/three2Green.4787451b.jpg";